import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses } from "../../utils/siteUtils";
import PrimaryButton from "../../elements/primary-button";
import { mobileIs } from "../../utils/siteUtils";
import "./style.scss";
import { gtag } from "../../utils";
import moment from 'moment-timezone';

const NewsDetail = props => {
	const { lang, rendering, fields, page } = props;
  const { pc_title, m_title, publishdate, detail, colorScheme, buttonText, iconName, showDate } = fields;
  const isMobile = mobileIs()
  const [date, setDate] = useState(null)

  const back = () => {
    gtag('event', 'Component_info', {
      'component_name': 'NewsDetail',
      'page_title': page?.name
    });
    window.history.go(-1)
  }

  useEffect(() => {
    let newsDate = null
    if(!showDate?.value) {
      newsDate = (moment(publishdate?.value).format('LL')).split(' ')[0] + ', ' + moment(publishdate?.value).format('YYYY')
    } else {
      newsDate = moment(publishdate?.value).format('LL')
    }
    setDate(newsDate)
  }, [])

  const rootClasses = classNames("c-news-detail", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource}>
      <div className="c-news-detail__back" onClick={back}>
        <PrimaryButton {...{
          colorScheme: colorScheme,
          buttonText: buttonText,
          iconName: iconName,
        }}
        />
      </div>
      {!isMobile && <RichText tag="div" className="c-news-detail__title" field={pc_title} />}
      {isMobile && <RichText tag="div" className="c-news-detail__title" field={m_title} />}
      <div className="c-news-detail__tool">
        <div className="c-news-detail__tool__date">{ date }</div>
      </div>
      <RichText tag="div" className="c-news-detail__article" field={detail} />
    </div>
  );
};

export default 	NewsDetail;